import { EquatableKeyStackItem } from './EquatableKeyStackItem';
export class HeaderStackItem extends EquatableKeyStackItem {
    asHeader() {
        return this.value;
    }
    asBlockBase() {
        return this.value;
    }
}

//# sourceMappingURL=HeaderStackItem.js.map
